// extracted by mini-css-extract-plugin
export default {"container":"_c8a6f3dd","expandIcon":"_2f531897"};